<template>
  <section>
    <div class="mx-auto">
      <div class="print-button d-flex">
        <p><i class="el-icon-info"></i> Click here for QC Charts</p>
        <el-button @click="printCharts()" round size="mini" type="primary">
          <i class="el-icon-printer"></i> PRINT</el-button
        >
      </div>
      <div class="results-section" id="qc-chart-print-view" v-if="!loading">
        <div class="title-block" v-if="$route.query.drug">
          <h3><span>Drug: </span>{{ $route.query.drug }}</h3>
          <h3>
            <span>From Date: </span>{{ formatDate($route.query.from_date) }}
          </h3>
          <h3><span>To Date: </span>{{ formatDate($route.query.to_date) }}</h3>
        </div>
        <div class="title-block" v-else>
          <h3>
            <span>From Date: </span>{{ formatDate($route.query.from_date) }}
          </h3>
          <h3><span>To Date: </span>{{ formatDate($route.query.to_date) }}</h3>
        </div>
        <div class="qc-data">
          <div
            class="qc-graph"
            v-for="(graph, index) of qcGraphsSvgs"
            :key="index"
          >
            <div v-html="graph"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import ChartsHelper from "@/mixins/ChartsHelper";
import Highcharts from "@/config/highcharts";

export default {
  components: {},
  mixins: [ChartsHelper],
  data() {
    return {
      loading: false,
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date();
        },
      },
      options: [],
      value: "",
      value1: [],
      Qc1ReportData: {
        categories: [],
        data: [],
      },
      Qc2ReportData: {
        categories: [],
        data: [],
      },
      Qc3ReportData: {
        categories: [],
        data: [],
      },
      Qc4ReportData: {
        categories: [],
        data: [],
      },
      utakhcData: {
        categories: [],
        data: [],
      },
      noData: false,
      orderBy: "drug",
      orderType: "asc",
      qcGraphsSvgs: [],
      title: "",
    };
  },
  mounted() {
    this.showCharts();
  },
  computed: {
    ...mapGetters("qcCharts", [
      "getQCChartReportData",
      "getQCChartPrintReportData",
      "getQCChartReportValidationErrors",
      "getQCChartChartSvgs",
    ]),
  },
  methods: {
    printCharts() {
      window.print();
    },
    showCharts() {
      this.qcGraphsSvgs = [...this.getQCChartChartSvgs];
      this.setPageTitle();

      setTimeout(() => {
        this.printCharts();
      }, 300);
    },
    async generateCharts() {
      this.loading = true;
      if (this.getQCChartPrintReportData) {
        this.Qc1ReportData = this.getQCChartPrintReportData.qcl
          ? { ...this.getQCChartPrintReportData.qcl }
          : {};
        this.Qc2ReportData = this.getQCChartPrintReportData.qcm
          ? { ...this.getQCChartPrintReportData.qcm }
          : {};
        this.Qc3ReportData = this.getQCChartPrintReportData.qch
          ? { ...this.getQCChartPrintReportData.qch }
          : {};
        this.Qc4ReportData = this.getQCChartPrintReportData.calibration
          ? { ...this.getQCChartPrintReportData.calibration }
          : {};
        this.utakhcData = this.getQCChartPrintReportData.utakhc
          ? { ...this.getQCChartPrintReportData.utakhc }
          : {};
      }

      if (
        (this.Qc1ReportData &&
          this.Qc1ReportData.data &&
          this.Qc1ReportData.data.length) ||
        (this.Qc2ReportData &&
          this.Qc2ReportData.data &&
          this.Qc2ReportData.data.length) ||
        (this.Qc3ReportData &&
          this.Qc3ReportData.data &&
          this.Qc3ReportData.data.length) ||
        (this.Qc4ReportData &&
          this.Qc4ReportData.data &&
          this.Qc4ReportData.data.length) ||
        (this.utakhcData && this.utakhcData.data && this.utakhcData.data.length)
      ) {
        this.noData = false;
      } else {
        this.noData = true;
      }

      this.loading = false;
    },

    setPageTitle() {
      if (this.$route.query.drug) {
        this.value = this.$route.query.drug;
        this.value1[0] = this.$route.query.from_date;
        this.value1[1] = this.$route.query.to_date;
        this.title = `${this.value}_${this.value1[0]}_${this.value1[1]}`;
        document.title = window.parent.document.title = this.title;
      } else {
        this.value = "UTAK HC1";
        this.value1[0] = this.$route.query.from_date;
        this.value1[1] = this.$route.query.to_date;
        this.title = `${this.value}_${this.value1[0]}_${this.value1[1]}`;
        document.title = window.parent.document.title = this.title;
      }
    },

    prepareParams() {
      let selectedResultFiles = this.$route.query.result_files.split(",");
      let params = {
        from_date: this.$route.query.from_date,
        to_date: this.$route.query.to_date,
        drug: this.$route.query.drug,
        test: this.$route.query.test,
      };

      if (selectedResultFiles && selectedResultFiles.indexOf("all") != -1) {
        params.include_all_files = true;
      } else if (selectedResultFiles) {
        params.include_files = selectedResultFiles;
      }
      return params;
    },
    downloadPdf() {
      Highcharts.exportCharts([window.qc2Chart, window.qc1Chart], {
        type: "application/pdf",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.print-button {
  text-align: right;
  margin: 1em auto;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 0px 10px 10px;
  margin-bottom: 20px;
  border-bottom: 1px dashed #dddddd;
  p {
    color: #727272;
    font-weight: 500;
    margin: 0;
    font-size: 0.85em;
    line-height: 1;
  }
}
.results-section {
  margin: 0 auto;
}
.empty-msg {
  display: inline-block;
  background-color: #ffffff;
  padding: 2em;
  border-radius: 10px;
  margin-top: 8%;
  box-shadow: 0 0 10px 0 #efefef;
}
#qc-chart-print-view {
  width: 1000px;
}
.title-block {
  display: flex;
  gap: 10px;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 20px 20px;
}
</style>

<style>
@media print {
  body * {
    visibility: hidden;
  }
  #qc-chart-print-view {
    width: 1000px;
  }
  #qc-chart-print-view,
  #qc-chart-print-view * {
    visibility: visible;
  }
  #qc-chart-print-view {
    position: absolute;
    left: 0;
    top: 0;
  }

  .chart-print-view {
    page-break-before: always !important;
    page-break-inside: avoid !important;
  }

  @page {
    size: A4;
    margin: 31mm 17mm 17mm 17mm; /* auto is the initial value */
    /* margin: 0; */ /* this affects the margin in the printer settings */
  }

  .title-block {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  .highcharts-scrollbar {
    display: none;
  }
}
</style>
